// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Playwrite+CU:wght@100..400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-left-3 {
  left: -0.75rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-28 {
  bottom: 7rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.right-0 {
  right: 0px;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.top-0 {
  top: 0px;
}
.top-0\\.5 {
  top: 0.125rem;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-12 {
  top: 3rem;
}
.top-2 {
  top: 0.5rem;
}
.top-32 {
  top: 8rem;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.col-span-full {
  grid-column: 1 / -1;
}
.m-4 {
  margin: 1rem;
}
.m-5 {
  margin: 1.25rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-7 {
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-ml-9 {
  margin-left: -2.25rem;
}
.-mt-24 {
  margin-top: -6rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-40 {
  margin-bottom: 10rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-10 {
  margin-left: 2.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-40 {
  margin-left: 10rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-60 {
  margin-left: 15rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-\\[100px\\] {
  margin-left: 100px;
}
.ml-\\[250px\\] {
  margin-left: 250px;
}
.ml-\\[280px\\] {
  margin-left: 280px;
}
.ml-auto {
  margin-left: auto;
}
.mr-10 {
  margin-right: 2.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-40 {
  margin-top: 10rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[300px\\] {
  margin-top: 300px;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-\\[60px\\] {
  width: 60px;
  height: 60px;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-3 {
  height: 0.75rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[137px\\] {
  height: 137px;
}
.h-\\[138px\\] {
  height: 138px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[19px\\] {
  height: 19px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[209px\\] {
  height: 209px;
}
.h-\\[210px\\] {
  height: 210px;
}
.h-\\[212px\\] {
  height: 212px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[27px\\] {
  height: 27px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30vh\\] {
  height: 30vh;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[35vh\\] {
  height: 35vh;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[430px\\] {
  height: 430px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[4px\\] {
  height: 4px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[547px\\] {
  height: 547px;
}
.h-\\[55vh\\] {
  height: 55vh;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[81px\\] {
  height: 81px;
}
.h-\\[96px\\] {
  height: 96px;
}
.h-\\[98px\\] {
  height: 98px;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[140px\\] {
  max-height: 140px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[600px\\] {
  max-height: 600px;
}
.max-h-full {
  max-height: 100%;
}
.min-h-\\[670px\\] {
  min-height: 670px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[105px\\] {
  width: 105px;
}
.w-\\[1113px\\] {
  width: 1113px;
}
.w-\\[121px\\] {
  width: 121px;
}
.w-\\[125px\\] {
  width: 125px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[143px\\] {
  width: 143px;
}
.w-\\[145px\\] {
  width: 145px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[152px\\] {
  width: 152px;
}
.w-\\[156px\\] {
  width: 156px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[208px\\] {
  width: 208px;
}
.w-\\[232px\\] {
  width: 232px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[270px\\] {
  width: 270px;
}
.w-\\[28\\%\\] {
  width: 28%;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[312px\\] {
  width: 312px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[370px\\] {
  width: 370px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[451px\\] {
  width: 451px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[550px\\] {
  width: 550px;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[640px\\] {
  width: 640px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[65px\\] {
  width: 65px;
}
.w-\\[68\\%\\] {
  width: 68%;
}
.w-\\[688px\\] {
  width: 688px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[750px\\] {
  width: 750px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[900px\\] {
  width: 900px;
}
.w-\\[91px\\] {
  width: 91px;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-\\[952px\\] {
  width: 952px;
}
.w-\\[98px\\] {
  width: 98px;
}
.w-\\[991px\\] {
  width: 991px;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[399px\\] {
  min-width: 399px;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-96 {
  max-width: 24rem;
}
.max-w-\\[347px\\] {
  max-width: 347px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[690px\\] {
  max-width: 690px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.table-auto {
  table-layout: auto;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-5 {
  --tw-translate-y: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-evenly;
}
.justify-items-center {
  justify-items: center;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-32 {
  gap: 8rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-\\[2rem\\] {
  gap: 2rem;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-12 {
  column-gap: 3rem;
}
.gap-x-16 {
  column-gap: 4rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-20 {
  column-gap: 5rem;
}
.gap-x-28 {
  column-gap: 7rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-56 {
  column-gap: 14rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-x-96 {
  column-gap: 24rem;
}
.gap-x-\\[75px\\] {
  column-gap: 75px;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.gap-y-8 {
  row-gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-\\[22px\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(22px * var(--tw-space-x-reverse));
  margin-left: calc(22px * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-gray-300 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.text-wrap {
  text-wrap: wrap;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-\\[48px\\] {
  border-radius: 48px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-tl-\\[14px\\] {
  border-top-left-radius: 14px;
}
.rounded-tl-\\[4px\\] {
  border-top-left-radius: 4px;
}
.rounded-tr-\\[14px\\] {
  border-top-right-radius: 14px;
}
.rounded-tr-\\[4px\\] {
  border-top-right-radius: 4px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-\\[\\#22C55E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3CC8A1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(60 200 161 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3F3F46\\] {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.border-\\[\\#60B0FA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(96 176 250 / var(--tw-border-opacity, 1));
}
.border-\\[\\#A1A1AA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D4D4D8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E5E5E5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EF4444\\] {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF0000\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF453A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 69 58 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FF9741\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 151 65 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ffff\\] {
  border-color: #ffff;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/5 {
  border-color: rgb(255 255 255 / 0.05);
}
.bg-\\[\\#047857\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#059669\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#28C3A6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(40 195 166 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#30b58f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(48 181 143 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#34D399\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3CC8A1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 161 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3CC8A1\\]\\/10 {
  background-color: rgb(60 200 161 / 0.1);
}
.bg-\\[\\#60B0FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(96 176 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6EE7B7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#82c7b4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(130 199 180 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#A1A1AA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#A7F3D0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D4D4D8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DCFCE7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E4E4E7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDF2F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 242 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EF4444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F4F4F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAFAFA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEE2E2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF453A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 69 58 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF9741\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 151 65 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFA500\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 165 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE6D4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 230 212 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFE9D6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 233 214 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d8dbe0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(216 219 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffff\\] {
  background-color: #ffff;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#28C3A6\\] {
  --tw-gradient-from: #28C3A6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(40 195 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#34D399\\] {
  --tw-gradient-to: #34D399 var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-white\\/30 {
  fill: rgb(255 255 255 / 0.3);
}
.fill-white\\/60 {
  fill: rgb(255 255 255 / 0.6);
}
.object-contain {
  object-fit: contain;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[0\\.5rem\\] {
  padding: 0.5rem;
}
.p-\\[2rem\\] {
  padding: 2rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.px-\\[4px\\] {
  padding-left: 4px;
  padding-right: 4px;
}
.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-\\[4\\.25rem\\] {
  padding-bottom: 4.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-\\[0\\.25rem\\] {
  padding-top: 0.25rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-justify {
  text-align: justify;
}
.text-end {
  text-align: end;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[48px\\] {
  font-size: 48px;
}
.text-\\[64px\\] {
  font-size: 64px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/6 {
  font-size: 0.875rem;
  line-height: 1.5rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.leading-\\[29px\\] {
  line-height: 29px;
}
.leading-\\[35px\\] {
  line-height: 35px;
}
.leading-\\[36px\\] {
  line-height: 36px;
}
.leading-\\[38px\\] {
  line-height: 38px;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#193154\\] {
  --tw-text-opacity: 1;
  color: rgb(25 49 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#27272A\\] {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#282F5A\\] {
  --tw-text-opacity: 1;
  color: rgb(40 47 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#28C3A6\\] {
  --tw-text-opacity: 1;
  color: rgb(40 195 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#34D399\\] {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3CC8A1\\] {
  --tw-text-opacity: 1;
  color: rgb(60 200 161 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3F3F46\\] {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#52525B\\] {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.text-\\[\\#71717A\\] {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A1A1AA\\] {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D4D4D8\\] {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ED8936\\] {
  --tw-text-opacity: 1;
  color: rgb(237 137 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF453A\\] {
  --tw-text-opacity: 1;
  color: rgb(255 69 58 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF7A28\\] {
  --tw-text-opacity: 1;
  color: rgb(255 122 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF9741\\] {
  --tw-text-opacity: 1;
  color: rgb(255 151 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFF\\] {
  color: #FFFF;
}
.text-\\[\\#ffff\\] {
  color: #ffff;
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.placeholder-transparent::placeholder {
  color: transparent;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0px 4px 10px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0px 4px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-orangeBlur {
  --tw-shadow: 1px 4px 46.1px 0 rgba(255, 151, 65, 0.5);
  --tw-shadow-colored: 1px 4px 46.1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-white\\/10 {
  --tw-shadow-color: rgb(255 255 255 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[max-height\\] {
  transition-property: max-height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[--anchor-gap\\:var\\(--spacing-1\\)\\] {
  --anchor-gap: var(--spacing-1);
}
body {
  background-color: #f4f4f5;
  font-family: "Inter", sans-serif;
  overflow-y: auto;
}

:root {
  --bg-color: #ffffff;
  --text-color: #000000;
}
.dark {
  --bg-color: #000000;
  --text-color: #ffffff;
}

html {
  scroll-behavior: smooth;
}

@keyframes heartBeat {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.custom-heartbeat {
  animation: heartBeat 3s infinite ease-in-out;
}

input[type="search"]::-webkit-search-cancel-button {
  filter: hue-rotate(150deg) saturate(5); /* Green color ke liye adjust kiya gaya hai */
}

/* HTML: */
.loading {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  aspect-ratio: 4;
  background: radial-gradient(circle closest-side, #000 90%, #0000) 0 /
    calc(100% / 3) 100% space;
  clip-path: inset(0 100% 0 0);
  animation: l1 1s steps(4) infinite;
}
@keyframes l1 {
  to {
    clip-path: inset(0 -34% 0 0);
  }
}

/* Add this CSS to your styles */
input[type="radio"] {
  appearance: none; /* Remove default styling */
  width: 20px; /* Set width */
  height: 20px; /* Set height */
  border: 2px solid #000000; /* Border color */
  border-radius: 50%; /* Make it circular */
  cursor: pointer; /* Change cursor */
  position: relative; /* Position relative for the pseudo-element */
}

/* Create a pseudo-element for the inner circle */
input[type="radio"]::before {
  content: ""; /* Required for pseudo-elements */
  position: absolute; /* Position it absolutely */
  top: 50%; /* Adjust to create padding */
  left: 50%; /* Adjust to create padding */
  width: 12px; /* Inner circle width */
  height: 12px; /* Inner circle height */
  border-radius: 50%; /* Make it circular */
  transform: translate(-50%, -50%);
  background-color: transparent; /* Default background */
  transition: background-color 0.2s; /* Smooth transition */
}

/* Change the background color when checked */
input[type="radio"]:checked::before {
  background-color: #3cc8a1; /* Change background color when checked */
}

/* Change border color when checked */
input[type="radio"]:checked {
  border: 2px solid #3cc8a1; /* Change border color when checked */
}

.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  background: #fff;
  border-radius: 48px;
  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 30px;
  width: 1163px;
}

.swiper-slide img {
  display: block;
  border-radius: 100%;
  width: 246px;
  height: 246px;
  object-fit: cover;
}

@media (max-width: 1536px) {
  .swiper-slide img {
    display: block;
    border-radius: 100%;
    width: 300px; /* Adjust width for screens 1536px and above */
    height: 200px; /* Adjust height for screens 1536px and above */
    object-fit: cover;
  }
}

@media (max-width: 1280px) {
  .swiper-slide img {
    display: block;
    border-radius: 100%;
    width: 250px;
    height: 130px;
    object-fit: cover;
  }

  .swiper-slide {
    text-align: center;
    background: #fff;
    border-radius: 48px;
    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 25px;
    width: 1163px;
  }
}

@media (max-width: 768px) {
  .swiper-slide img {
    display: block;
    border-radius: 100%;
    width: 250px;
    height: 130px;
    object-fit: cover;
  }

  .swiper-slide {
    text-align: center;
    background: #fff;
    border-radius: 48px;
    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 25px;
    width: 1163px;
  }
}

.swiper-slide:nth-child(1n) {
  margin-left: 140px;

  width: 60%;
}

@media (max-width: 768px) {
  .swiper-slide:nth-child(1n) {
    margin-left: 140px;

    width: 100%;
  }
}

/* Style for the container */

/* Style for the DeepChat component */
.deep-chat {
  border: none; /* Remove all borders */
  width: 200px; /* Full width of the container */
}

/* Responsive styling for smaller screens */
@media (max-width: 768px) {
  .deep-chat {
    width: 180px; /* Reduce the width for smaller screens */
  }
}
.placeholder\\:pl-1::placeholder {
  padding-left: 0.25rem;
}
.placeholder\\:text-start::placeholder {
  text-align: start;
}
.placeholder\\:text-\\[12px\\]::placeholder {
  font-size: 12px;
}
.placeholder\\:text-\\[14px\\]::placeholder {
  font-size: 14px;
}
.placeholder\\:text-\\[16px\\]::placeholder {
  font-size: 16px;
}
.placeholder\\:font-light::placeholder {
  font-weight: 300;
}
.placeholder\\:font-normal::placeholder {
  font-weight: 400;
}
.placeholder\\:font-semibold::placeholder {
  font-weight: 600;
}
.placeholder\\:text-\\[\\#3F3F46\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#A1A1AA\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#D4D4D8\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:left-\\[2px\\]::after {
  content: var(--tw-content);
  left: 2px;
}
.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:border-none:last-child {
  border-style: none;
}
.checked\\:border-\\[\\#3CC8A1\\]:checked {
  --tw-border-opacity: 1;
  border-color: rgb(60 200 161 / var(--tw-border-opacity, 1));
}
.checked\\:bg-\\[\\#3CC8A1\\]:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 161 / var(--tw-bg-opacity, 1));
}
.hover\\:border:hover {
  border-width: 1px;
}
.hover\\:border-\\[\\#3CC8A1\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(60 200 161 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#1f9c7f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 156 127 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2c9d7d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(44 157 125 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2e9e7e\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(46 158 126 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#34b08c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 176 140 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#34b38f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 179 143 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#35b38d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(53 179 141 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#39be98\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(57 190 152 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#3CC8A1\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 161 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#3CC8A5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 165 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FF0000\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FF453A\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 69 58 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FF9741\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 151 65 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FFDAC4\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 218 196 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#ae615e\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(174 97 94 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#d9d9db\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e3863a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(227 134 58 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e4e4e6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#e8924d\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 146 77 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-gradient-to-r:hover {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.hover\\:from-\\[\\#FF9741\\]:hover {
  --tw-gradient-from: #FF9741 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 151 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-\\[\\#FF5722\\]:hover {
  --tw-gradient-to: #FF5722 var(--tw-gradient-to-position);
}
.hover\\:text-\\[\\#171719\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(23 23 25 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#28A079\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(40 160 121 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#3CC8A1\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(60 200 161 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#3F3F46\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#3cc8a1\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(60 200 161 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#60B0FA\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(96 176 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#FF453A\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 69 58 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#ff9b48\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 155 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#ffff\\]:hover {
  color: #ffff;
}
.hover\\:text-gray-400:hover {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-70:hover {
  opacity: 0.7;
}
.hover\\:opacity-75:hover {
  opacity: 0.75;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-85:hover {
  opacity: 0.85;
}
.hover\\:shadow-greenBlur:hover {
  --tw-shadow: 0px 0px 35px 0  rgba(60, 200, 161, 0.5);
  --tw-shadow-colored: 0px 0px 35px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#282F5A\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(40 47 90 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#28C3A6\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(40 195 166 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#3CC8A1\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(60 200 161 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-gray-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-\\[\\#3CC8A1\\]:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 161 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-white:disabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.group:hover .group-hover\\:bg-\\[\\#3CC8A1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 161 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#60B0FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(96 176 250 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#3CC8A1\\] {
  --tw-text-opacity: 1;
  color: rgb(60 200 161 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-\\[\\#3CC8A1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(60 200 161 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.peer:focus ~ .peer-focus\\:ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus ~ .peer-focus\\:ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.data-\\[closed\\]\\:scale-95[data-closed] {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[focus\\]\\:bg-white\\/10[data-focus] {
  background-color: rgb(255 255 255 / 0.1);
}
.data-\\[hover\\]\\:bg-gray-700[data-hover] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.data-\\[open\\]\\:bg-gray-700[data-open] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.data-\\[closed\\]\\:opacity-0[data-closed] {
  opacity: 0;
}
.data-\\[focus\\]\\:outline-1[data-focus] {
  outline-width: 1px;
}
.data-\\[focus\\]\\:outline-white[data-focus] {
  outline-color: #fff;
}
.group[data-focus] .group-data-\\[focus\\]\\:inline {
  display: inline;
}
.dark\\:border:is(.dark *) {
  border-width: 1px;
}
.dark\\:border-\\[1px\\]:is(.dark *) {
  border-width: 1px;
}
.dark\\:border-\\[2px\\]:is(.dark *) {
  border-width: 2px;
}
.dark\\:border-r-\\[1px\\]:is(.dark *) {
  border-right-width: 1px;
}
.dark\\:border-\\[\\#3A3A48\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(58 58 72 / var(--tw-border-opacity, 1));
}
.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.dark\\:bg-\\[\\#1E1E2A\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#3A3A48\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 72 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:dark\\:bg-\\[\\#1E1E2A\\]:is(.dark *):is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 42 / var(--tw-bg-opacity, 1));
}
.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:border-\\[\\#FF9741\\]:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 151 65 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#4A4A5A\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 74 90 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gradient-to-r:hover:is(.dark *) {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.dark\\:hover\\:from-\\[\\#1E1E2A\\]:hover:is(.dark *) {
  --tw-gradient-from: #1E1E2A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 30 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:hover\\:to-\\[\\#3E3E55\\]:hover:is(.dark *) {
  --tw-gradient-to: #3E3E55 var(--tw-gradient-to-position);
}
.dark\\:hover\\:text-\\[\\#FF9741\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 151 65 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:shadow-lg:hover:is(.dark *) {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.dark\\:hover\\:shadow-\\[\\#FF9741\\]\\/60:hover:is(.dark *) {
  --tw-shadow-color: rgb(255 151 65 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.peer:focus ~ .dark\\:peer-focus\\:ring-blue-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:right-3 {
    right: 0.75rem;
  }

  .sm\\:m-10 {
    margin: 2.5rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:ml-16 {
    margin-left: 4rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:h-\\[27px\\] {
    height: 27px;
  }

  .sm\\:h-\\[410px\\] {
    height: 410px;
  }

  .sm\\:w-\\[180px\\] {
    width: 180px;
  }

  .sm\\:w-\\[400px\\] {
    width: 400px;
  }

  .sm\\:w-\\[430px\\] {
    width: 430px;
  }

  .sm\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .sm\\:w-\\[95\\%\\] {
    width: 95%;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-x-14 {
    column-gap: 3.5rem;
  }

  .sm\\:gap-x-36 {
    column-gap: 9rem;
  }

  .sm\\:gap-x-40 {
    column-gap: 10rem;
  }

  .sm\\:gap-x-60 {
    column-gap: 15rem;
  }

  .sm\\:space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .sm\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .sm\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .sm\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .sm\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .sm\\:text-\\[36px\\] {
    font-size: 36px;
  }

  .sm\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:leading-\\[45px\\] {
    line-height: 45px;
  }

  .sm\\:leading-\\[50px\\] {
    line-height: 50px;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:right-\\[280px\\] {
    right: 280px;
  }

  .md\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .md\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:-mt-28 {
    margin-top: -7rem;
  }

  .md\\:-mt-48 {
    margin-top: -12rem;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:ml-0 {
    margin-left: 0px;
  }

  .md\\:ml-5 {
    margin-left: 1.25rem;
  }

  .md\\:ml-\\[200px\\] {
    margin-left: 200px;
  }

  .md\\:ml-\\[250px\\] {
    margin-left: 250px;
  }

  .md\\:mr-0 {
    margin-right: 0px;
  }

  .md\\:mr-20 {
    margin-right: 5rem;
  }

  .md\\:mr-6 {
    margin-right: 1.5rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mt-40 {
    margin-top: 10rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:mt-56 {
    margin-top: 14rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-14 {
    height: 3.5rem;
  }

  .md\\:h-\\[47px\\] {
    height: 47px;
  }

  .md\\:h-\\[500px\\] {
    height: 500px;
  }

  .md\\:h-\\[520px\\] {
    height: 520px;
  }

  .md\\:h-\\[77vh\\] {
    height: 77vh;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-1\\/4 {
    width: 25%;
  }

  .md\\:w-14 {
    width: 3.5rem;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-\\[25\\%\\] {
    width: 25%;
  }

  .md\\:w-\\[261px\\] {
    width: 261px;
  }

  .md\\:w-\\[280px\\] {
    width: 280px;
  }

  .md\\:w-\\[321px\\] {
    width: 321px;
  }

  .md\\:w-\\[35\\%\\] {
    width: 35%;
  }

  .md\\:w-\\[435px\\] {
    width: 435px;
  }

  .md\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:gap-32 {
    gap: 8rem;
  }

  .md\\:gap-x-3 {
    column-gap: 0.75rem;
  }

  .md\\:space-x-10 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--tw-space-x-reverse));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:text-end {
    text-align: end;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:placeholder\\:text-\\[16px\\]::placeholder {
    font-size: 16px;
  }
}
@media (min-width: 1024px) {

  .lg\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .lg\\:ml-\\[150px\\] {
    margin-left: 150px;
  }

  .lg\\:ml-\\[250px\\] {
    margin-left: 250px;
  }

  .lg\\:ml-\\[260px\\] {
    margin-left: 260px;
  }

  .lg\\:mr-0 {
    margin-right: 0px;
  }

  .lg\\:mr-\\[130px\\] {
    margin-right: 130px;
  }

  .lg\\:mr-\\[200px\\] {
    margin-right: 200px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-6 {
    height: 1.5rem;
  }

  .lg\\:h-\\[172px\\] {
    height: 172px;
  }

  .lg\\:h-\\[248px\\] {
    height: 248px;
  }

  .lg\\:h-\\[250px\\] {
    height: 250px;
  }

  .lg\\:h-\\[274px\\] {
    height: 274px;
  }

  .lg\\:h-\\[500px\\] {
    height: 500px;
  }

  .lg\\:h-\\[56px\\] {
    height: 56px;
  }

  .lg\\:h-\\[590px\\] {
    height: 590px;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:w-56 {
    width: 14rem;
  }

  .lg\\:w-6 {
    width: 1.5rem;
  }

  .lg\\:w-\\[185px\\] {
    width: 185px;
  }

  .lg\\:w-\\[200px\\] {
    width: 200px;
  }

  .lg\\:w-\\[230px\\] {
    width: 230px;
  }

  .lg\\:w-\\[240px\\] {
    width: 240px;
  }

  .lg\\:w-\\[242px\\] {
    width: 242px;
  }

  .lg\\:w-\\[263px\\] {
    width: 263px;
  }

  .lg\\:w-\\[310px\\] {
    width: 310px;
  }

  .lg\\:w-\\[320px\\] {
    width: 320px;
  }

  .lg\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .lg\\:w-\\[50px\\] {
    width: 50px;
  }

  .lg\\:w-\\[58rem\\] {
    width: 58rem;
  }

  .lg\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .lg\\:w-\\[720px\\] {
    width: 720px;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:gap-x-0 {
    column-gap: 0px;
  }

  .lg\\:gap-x-20 {
    column-gap: 5rem;
  }

  .lg\\:gap-x-24 {
    column-gap: 6rem;
  }

  .lg\\:space-x-16 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(4rem * var(--tw-space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:rounded-md {
    border-radius: 0.375rem;
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-\\[16px\\] {
    padding: 16px;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-8xl {
    font-size: 6rem;
    line-height: 1;
  }

  .lg\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .lg\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .lg\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .lg\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .lg\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .lg\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .lg\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .lg\\:text-\\[36px\\] {
    font-size: 36px;
  }

  .lg\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:leading-\\[55px\\] {
    line-height: 55px;
  }
}
@media (min-width: 1280px) {

  .xl\\:ml-\\[250px\\] {
    margin-left: 250px;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:h-12 {
    height: 3rem;
  }

  .xl\\:h-\\[503px\\] {
    height: 503px;
  }

  .xl\\:h-\\[557px\\] {
    height: 557px;
  }

  .xl\\:h-\\[70px\\] {
    height: 70px;
  }

  .xl\\:w-12 {
    width: 3rem;
  }

  .xl\\:w-64 {
    width: 16rem;
  }

  .xl\\:w-\\[273px\\] {
    width: 273px;
  }

  .xl\\:w-\\[308px\\] {
    width: 308px;
  }

  .xl\\:w-\\[320px\\] {
    width: 320px;
  }

  .xl\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .xl\\:w-\\[489px\\] {
    width: 489px;
  }

  .xl\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .xl\\:w-\\[610px\\] {
    width: 610px;
  }

  .xl\\:w-\\[665px\\] {
    width: 665px;
  }

  .xl\\:w-\\[720px\\] {
    width: 720px;
  }

  .xl\\:w-\\[750px\\] {
    width: 750px;
  }

  .xl\\:w-\\[75rem\\] {
    width: 75rem;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:gap-2 {
    gap: 0.5rem;
  }

  .xl\\:gap-x-36 {
    column-gap: 9rem;
  }

  .xl\\:space-x-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--tw-space-x-reverse));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .xl\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .xl\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .xl\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .xl\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .xl\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .xl\\:text-\\[38px\\] {
    font-size: 38px;
  }

  .xl\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xl\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1536px) {

  .\\32xl\\:h-6 {
    height: 1.5rem;
  }

  .\\32xl\\:h-\\[75\\%\\] {
    height: 75%;
  }

  .\\32xl\\:w-11 {
    width: 2.75rem;
  }

  .\\32xl\\:w-\\[105rem\\] {
    width: 105rem;
  }

  .\\32xl\\:w-\\[200px\\] {
    width: 200px;
  }

  .\\32xl\\:w-\\[280px\\] {
    width: 280px;
  }

  .\\32xl\\:w-\\[308px\\] {
    width: 308px;
  }

  .\\32xl\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .\\32xl\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .\\32xl\\:w-\\[745px\\] {
    width: 745px;
  }

  .\\32xl\\:w-\\[800px\\] {
    width: 800px;
  }

  .\\32xl\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .\\32xl\\:w-\\[99\\%\\] {
    width: 99%;
  }

  .\\32xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .\\32xl\\:justify-center {
    justify-content: center;
  }

  .\\32xl\\:gap-x-20 {
    column-gap: 5rem;
  }

  .\\32xl\\:gap-x-72 {
    column-gap: 18rem;
  }

  .\\32xl\\:space-x-\\[300px\\] > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(300px * var(--tw-space-x-reverse));
    margin-left: calc(300px * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-y-10 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
  }

  .\\32xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\32xl\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .\\32xl\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .\\32xl\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .\\32xl\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .\\32xl\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .\\32xl\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .\\32xl\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .\\32xl\\:text-\\[64px\\] {
    font-size: 64px;
  }

  .\\32xl\\:leading-\\[77px\\] {
    line-height: 77px;
  }
}
.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAGnB;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC,EAAE,6CAA6C;AACvF;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf;6BAC2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,gCAAgC;AAChC;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,WAAW,EAAE,cAAc;EAC3B,YAAY,EAAE,eAAe;EAC7B,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB,EAAE,qBAAqB;EACzC,eAAe,EAAE,kBAAkB;EACnC,kBAAkB,EAAE,6CAA6C;AACnE;;AAEA,iDAAiD;AACjD;EACE,WAAW,EAAE,iCAAiC;EAC9C,kBAAkB,EAAE,2BAA2B;EAC/C,QAAQ,EAAE,6BAA6B;EACvC,SAAS,EAAE,6BAA6B;EACxC,WAAW,EAAE,uBAAuB;EACpC,YAAY,EAAE,wBAAwB;EACtC,kBAAkB,EAAE,qBAAqB;EACzC,gCAAgC;EAChC,6BAA6B,EAAE,uBAAuB;EACtD,iCAAiC,EAAE,sBAAsB;AAC3D;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA,qCAAqC;AACrC;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,YAAY,EAAE,8CAA8C;IAC5D,aAAa,EAAE,+CAA+C;IAC9D,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;;EAElB,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;;IAElB,WAAW;EACb;AACF;;AAEA,4BAA4B;;AAE5B,qCAAqC;AACrC;EACE,YAAY,EAAE,uBAAuB;EACrC,YAAY,EAAE,gCAAgC;AAChD;;AAEA,2CAA2C;AAC3C;EACE;IACE,YAAY,EAAE,yCAAyC;EACzD;AACF;AA7MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA,wBA8MA;EA9MA,wDA8MA;EA9MA;AA8MA;AA9MA;EAAA,gBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,4DA8MA;EA9MA,oEA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,oDA8MA;EA9MA,0DA8MA;EA9MA;AA8MA;AA9MA;EAAA,+EA8MA;EA9MA,mGA8MA;EA9MA;AA8MA;AA9MA;EAAA,8BA8MA;EA9MA;AA8MA;AA9MA;EAAA,2GA8MA;EA9MA,yGA8MA;EA9MA;AA8MA;AA9MA;EAAA,2GA8MA;EA9MA,yGA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,0BA8MA;EA9MA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,2GA8MA;EA9MA,yGA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,iBA8MA;EA9MA,iBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,sBA8MA;EA9MA;AA8MA;AA9MA;EAAA,kBA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,4DA8MA;EA9MA,kEA8MA;EA9MA;AA8MA;AA9MA;EAAA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;EAAA,+EA8MA;EA9MA,mGA8MA;EA9MA;AA8MA;AA9MA;EAAA,wCA8MA;EA9MA;AA8MA;AA9MA;EAAA,oBA8MA;EA9MA;AA8MA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,uDA8MA;IA9MA;EA8MA;;EA9MA;IAAA,qBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,qBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,oBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,oBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,kBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,sDA8MA;IA9MA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,uDA8MA;IA9MA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,2DA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,kBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,iBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,iBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,kBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,eA8MA;IA9MA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,oDA8MA;IA9MA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,uDA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,iBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,eA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,eA8MA;IA9MA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,uDA8MA;IA9MA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,2DA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;;EA9MA;IAAA,mBA8MA;IA9MA;EA8MA;AAAA;AA9MA;;EAAA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,qDA8MA;IA9MA;EA8MA;;EA9MA;IAAA,uBA8MA;IA9MA,8DA8MA;IA9MA;EA8MA;;EA9MA;IAAA,kBA8MA;IA9MA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;;EA9MA;IAAA;EA8MA;AAAA;AA9MA;EAAA;AA8MA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Playwrite+CU:wght@100..400&display=swap\");\nbody {\n  background-color: #f4f4f5;\n  font-family: \"Inter\", sans-serif;\n  overflow-y: auto;\n}\n\n:root {\n  --bg-color: #ffffff;\n  --text-color: #000000;\n}\n.dark {\n  --bg-color: #000000;\n  --text-color: #ffffff;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n@keyframes heartBeat {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.05);\n  }\n}\n\n.custom-heartbeat {\n  animation: heartBeat 3s infinite ease-in-out;\n}\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  filter: hue-rotate(150deg) saturate(5); /* Green color ke liye adjust kiya gaya hai */\n}\n\n/* HTML: */\n.loading {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  aspect-ratio: 4;\n  background: radial-gradient(circle closest-side, #000 90%, #0000) 0 /\n    calc(100% / 3) 100% space;\n  clip-path: inset(0 100% 0 0);\n  animation: l1 1s steps(4) infinite;\n}\n@keyframes l1 {\n  to {\n    clip-path: inset(0 -34% 0 0);\n  }\n}\n\n/* Add this CSS to your styles */\ninput[type=\"radio\"] {\n  appearance: none; /* Remove default styling */\n  width: 20px; /* Set width */\n  height: 20px; /* Set height */\n  border: 2px solid #000000; /* Border color */\n  border-radius: 50%; /* Make it circular */\n  cursor: pointer; /* Change cursor */\n  position: relative; /* Position relative for the pseudo-element */\n}\n\n/* Create a pseudo-element for the inner circle */\ninput[type=\"radio\"]::before {\n  content: \"\"; /* Required for pseudo-elements */\n  position: absolute; /* Position it absolutely */\n  top: 50%; /* Adjust to create padding */\n  left: 50%; /* Adjust to create padding */\n  width: 12px; /* Inner circle width */\n  height: 12px; /* Inner circle height */\n  border-radius: 50%; /* Make it circular */\n  transform: translate(-50%, -50%);\n  background-color: transparent; /* Default background */\n  transition: background-color 0.2s; /* Smooth transition */\n}\n\n/* Change the background color when checked */\ninput[type=\"radio\"]:checked::before {\n  background-color: #3cc8a1; /* Change background color when checked */\n}\n\n/* Change border color when checked */\ninput[type=\"radio\"]:checked {\n  border: 2px solid #3cc8a1; /* Change border color when checked */\n}\n\n.swiper {\n  width: 100%;\n  height: 100%;\n}\n\n.swiper-slide {\n  text-align: center;\n  background: #fff;\n  border-radius: 48px;\n  /* Center slide text vertically */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  padding: 30px;\n  width: 1163px;\n}\n\n.swiper-slide img {\n  display: block;\n  border-radius: 100%;\n  width: 246px;\n  height: 246px;\n  object-fit: cover;\n}\n\n@media (max-width: 1536px) {\n  .swiper-slide img {\n    display: block;\n    border-radius: 100%;\n    width: 300px; /* Adjust width for screens 1536px and above */\n    height: 200px; /* Adjust height for screens 1536px and above */\n    object-fit: cover;\n  }\n}\n\n@media (max-width: 1280px) {\n  .swiper-slide img {\n    display: block;\n    border-radius: 100%;\n    width: 250px;\n    height: 130px;\n    object-fit: cover;\n  }\n\n  .swiper-slide {\n    text-align: center;\n    background: #fff;\n    border-radius: 48px;\n    /* Center slide text vertically */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 25px;\n    width: 1163px;\n  }\n}\n\n@media (max-width: 768px) {\n  .swiper-slide img {\n    display: block;\n    border-radius: 100%;\n    width: 250px;\n    height: 130px;\n    object-fit: cover;\n  }\n\n  .swiper-slide {\n    text-align: center;\n    background: #fff;\n    border-radius: 48px;\n    /* Center slide text vertically */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 25px;\n    width: 1163px;\n  }\n}\n\n.swiper-slide:nth-child(1n) {\n  margin-left: 140px;\n\n  width: 60%;\n}\n\n@media (max-width: 768px) {\n  .swiper-slide:nth-child(1n) {\n    margin-left: 140px;\n\n    width: 100%;\n  }\n}\n\n/* Style for the container */\n\n/* Style for the DeepChat component */\n.deep-chat {\n  border: none; /* Remove all borders */\n  width: 200px; /* Full width of the container */\n}\n\n/* Responsive styling for smaller screens */\n@media (max-width: 768px) {\n  .deep-chat {\n    width: 180px; /* Reduce the width for smaller screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
